import React from "react";
import { useNavigate } from "react-router-dom";
import { clearAdminSession, getAdminSession } from "../utils/adminAuth";

const SWAGGER_DOCS_URL = "https://www.vivacrea.ch/admin/docs-link";

const adminTiles = [
  {
    title: "Utilisateurs",
    value: "1 248",
    subtitle: "Comptes actifs cette semaine",
  },
  {
    title: "Services",
    value: "342",
    subtitle: "Services actuellement publies",
  },
  {
    title: "Signalements",
    value: "7",
    subtitle: "Elements a moderer en priorite",
  },
  {
    title: "Revenus",
    value: "24 300 EUR",
    subtitle: "Volume brut sur 30 jours",
  },
];

const AdminDashboard = () => {
  const navigate = useNavigate();
  const { user: adminUser } = getAdminSession();

  const openApiDocs = async () => {
    window.open(SWAGGER_DOCS_URL, "_blank", "noopener,noreferrer");
  };

  const handleLogout = () => {
    clearAdminSession();
    navigate("/admin/login?logout=1", { replace: true });

    // Fallback dur si un script externe perturbe la navigation SPA.
    if (window.location.pathname !== "/admin/login") {
      window.location.assign("/admin/login?logout=1");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-800 text-slate-100">
      <header className="border-b border-slate-700/70">
        <div className="max-w-7xl mx-auto px-6 py-5 flex items-center justify-between gap-4">
          <div>
            <p className="text-xs uppercase tracking-[0.28em] text-cyan-300">Vivacrea Admin</p>
            <h1 className="text-2xl font-black">Dashboard Back Office</h1>
          </div>
          <button
            type="button"
            onClick={handleLogout}
            className="px-4 py-2 rounded-lg bg-rose-500/90 text-white font-semibold hover:bg-rose-500"
          >
            Deconnexion
          </button>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-6 py-8">
        <section className="mb-8 rounded-2xl border border-cyan-500/40 bg-slate-900/70 p-6">
          <p className="text-slate-400 mb-1">Session admin</p>
          <h2 className="text-3xl font-black text-cyan-300">
            Bonjour {adminUser?.prenom || adminUser?.name || "Administrateur"}
          </h2>
          <p className="text-slate-300 mt-3">
            Cet espace est totalement separe du dashboard utilisateur et reserve aux operations de pilotage.
          </p>
        </section>

        <section className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 mb-8">
          {adminTiles.map((tile) => (
            <article
              key={tile.title}
              className="rounded-2xl border border-slate-700 bg-slate-900 p-5 shadow-lg shadow-slate-950/50"
            >
              <p className="text-sm text-slate-400">{tile.title}</p>
              <p className="text-3xl font-black text-cyan-300 mt-2">{tile.value}</p>
              <p className="text-sm text-slate-400 mt-2">{tile.subtitle}</p>
            </article>
          ))}
        </section>

        <section className="rounded-2xl border border-slate-700 bg-slate-900 p-6">
          <h3 className="text-xl font-bold mb-3">Actions rapides</h3>
          <div className="flex flex-wrap gap-3">
            <button className="px-4 py-2 rounded-lg bg-cyan-400 text-slate-950 font-semibold hover:bg-cyan-300">
              Gerer les comptes
            </button>
            <button className="px-4 py-2 rounded-lg bg-amber-400 text-slate-950 font-semibold hover:bg-amber-300">
              Moderer les signalements
            </button>
            <button className="px-4 py-2 rounded-lg bg-emerald-400 text-slate-950 font-semibold hover:bg-emerald-300">
              Exporter les rapports
            </button>
            <button
              type="button"
              onClick={async () => {
                try {
                  await openApiDocs();
                } catch (error) {
                  alert(error.message || "Impossible d'ouvrir la documentation");
                }
              }}
              className="px-4 py-2 rounded-lg bg-violet-300 text-slate-950 font-semibold hover:bg-violet-200"
            >
              Ouvrir la doc Swagger
            </button>
          </div>
        </section>
      </main>
    </div>
  );
};

export default AdminDashboard;
